module.exports = __webpack_public_path__ + "img/36.ea99c2b6.png";